import { Languages } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { strings } from '@/strings';

/** The code for each language, in that language. */
const ABBREVIATION: Record<'ar' | 'en', string> = { ar: 'ع', en: 'EN' };

/**
 * Two languages, so this is a toggle rather than a menu: a dropdown that opens
 * to reveal one alternative is two clicks to do what one can.
 *
 * The label is the code of the language you would switch TO — "EN" while you
 * are reading Arabic — written in that language. A code rather than the full
 * name because the top bar also carries a view switcher and an avatar, and
 * "English" was the widest thing in the row for the least information.
 *
 * The full name stays in `aria-label`: "EN" beside a globe is obvious to a
 * sighted person scanning the bar and useless to a screen reader.
 */
export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const next = language === 'ar' ? 'en' : 'ar';

  return (
    <button
      type="button"
      onClick={() => setLanguage(next)}
      aria-label={strings.languageSwitch}
      title={strings.languageSwitch}
      className="flex h-11 min-w-11 items-center justify-center gap-1.5 rounded-md border border-border-subtle px-2.5 text-sm font-medium text-ink transition-colors hover:bg-surface"
    >
      <Languages className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
      <span aria-hidden="true">{ABBREVIATION[next]}</span>
    </button>
  );
}
